"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SSRLogger = void 0;
class SSRLogger {
    error;
    warn;
    info;
    log;
    trace;
    buffer = [];
    constructor() {
        this.error = this.pushToBuffer('error');
        this.warn = this.pushToBuffer('warn');
        this.info = this.pushToBuffer('info');
        this.log = this.pushToBuffer('log');
        this.trace = this.pushToBuffer('trace');
    }
    pushToBuffer = (method) => (...params) => {
        // SSR logging should only be used in dev
        if (process.env.NODE_ENV !== 'development') {
            return;
        }
        this.buffer.push({
            method,
            params,
        });
    };
    getServerSideLogs = (flush = true) => {
        // SSR logging should only be used in dev
        if (process.env.NODE_ENV !== 'development') {
            return [];
        }
        const buffer = this.buffer;
        if (flush) {
            this.buffer = [];
        }
        return buffer;
    };
}
exports.SSRLogger = SSRLogger;
//# sourceMappingURL=logger.js.map